var _path, _path2, _path3, _path4, _path5, _path6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M19,0a1,1,0,0,1,.993.883L20,1V23a1,1,0,0,1-.883.993L19,24H11a1,1,0,0,1-.117-1.993L11,22h7V2H9.019L2,2.134V13a1,1,0,0,1-.883.993L1,14a1,1,0,0,1-.993-.883L0,13V1.154A1,1,0,0,1,.866.163L.981.154,9,0Z",
    transform: "translate(26 28) rotate(-180)",
    fill: "#07a5df"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M1,11a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H7A1,1,0,0,1,8,1v9a1,1,0,0,1-1,1Z",
    transform: "translate(22.682 1.868) rotate(45)",
    fill: "#0b67b2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M3.144,6.514l-3-5A1,1,0,0,1,1,0H7a1,1,0,0,1,.858,1.515l-3,5a1,1,0,0,1-1.715,0Z",
    transform: "translate(16.317 8.231) rotate(45)",
    fill: "#0b67b2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M6,0V2H0V0Z",
    transform: "translate(20.5 4.964) rotate(45)",
    fill: "#0b67b2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4_Copy_2",
    "data-name": "Path 4 Copy 2",
    d: "M11,0a1,1,0,0,1,.117,1.993L11,2H1A1,1,0,0,1,.883.007L1,0Z",
    transform: "translate(10 22)",
    fill: "#07a5df"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4_Copy_3",
    "data-name": "Path 4 Copy 3",
    d: "M11,0a1,1,0,0,1,.117,1.993L11,2H1A1,1,0,0,1,.883.007L1,0Z",
    transform: "translate(10 18)",
    fill: "#07a5df"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRe);
export default __webpack_public_path__ + "static/media/re.f6d85f2ee27c45cab3dc76faedc37e27.svg";
export { ForwardRef as ReactComponent };